import React, { useEffect, useRef } from "react";
import { IFrameModel } from "./models/IFrame.model";
import { TIFrameProps } from "./types/IFrame.types";
import "./index.scss";
import {
  isEditorActive,
  Link,
} from "@sitecore-jss/sitecore-jss-react";
import { anchorWithId } from "../../helpers/anchorWithId.helper";
import { LinkField } from "../../types/types";

const ExternalComponent = (props: TIFrameProps) => {
  const model = new IFrameModel(props);
  const { url, height } = model;
  const IframeRef = useRef<HTMLIFrameElement>(null);

  let timer = null;
  useEffect(() => {
    if (IframeRef.current && url) {
      IframeRef.current.src = url;
    }
  }, []);

  return (
    <div>
      <section className={"iframe"}>
        {isEditorActive() ? (
          <Link
            field={model?.fields?.RedirectionUrl as LinkField}
            className="stock-ticker-link"
          />
        ) : (
          model?.fields?.RedirectionUrl && (
            <a
              href={anchorWithId(
                model?.fields?.RedirectionUrl?.value?.href ?? '',
                model?.fields?.RedirectionUrl?.value?.anchor
              )}
              className="stock-ticker-link"
            ></a>
          )
        )}
        <iframe
          ref={IframeRef}
          style={{ height: `${height}px`, margin: "10px" }}
          title="iframe"
        ></iframe>
      </section>
    </div>
  );
};

export default ExternalComponent;
